import { render } from "./rights.vue?vue&type=template&id=463f687c&ts=true"
import script from "./rights.ts?vue&type=script&lang=ts&external"
export * from "./rights.ts?vue&type=script&lang=ts&external"

import "./rights.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__